"use client";

import { useEffect, useRef, useState } from "react";
import { canReloadForChunkError, chunkReloadStorage, reloadForChunkError } from "@/lib/chunk-reload";

export function useChunkReload(error: unknown): { planned: boolean; reloading: boolean } {
  const plannedRef = useRef<boolean | null>(null);
  if (plannedRef.current === null) plannedRef.current = canReloadForChunkError(error, chunkReloadStorage());
  const planned = plannedRef.current;
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (planned && !reloadForChunkError(chunkReloadStorage(), () => window.location.reload())) setFailed(true);
  }, [planned]);

  return { planned, reloading: planned && !failed };
}
